var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 267,
    viewBox: "0 0 228 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.276 63.3766C223.827 56.7634 227.922 47.3947 227.922 37.1993C227.922 16.5331 211.544 6.10352e-05 191.072 6.10352e-05C178.243 6.10352e-05 166.779 6.6132 160.228 16.8086C158.59 18.4619 12.0103 200.876 10.6455 203.08C4.09447 209.694 0 219.062 0 229.258C0 249.924 16.3776 266.457 36.8497 266.457C49.6788 266.457 61.1431 259.844 67.6941 249.648C69.0589 247.72 215.639 65.3054 217.276 63.3766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignBottom);
export default __webpack_public_path__ + "static/media/DesignBottom.ff0ca5fc5130103640e24c1c5bc06976.svg";
export { ForwardRef as ReactComponent };